module.exports = __webpack_public_path__ + "images/1b5426cfdeb0a01a043c8a181fdad2e4.png";